<template>
  <div>
    <!-- slot for parent component to activate the file changer -->
    <v-hover>
      <div slot-scope="{ hover }">
        <div name="activator">
          <v-responsive v-if="!value && !originalImage" aspect-ratio="1" class="grey lighten-3" @click="launchFilePicker()">
            <v-layout fill-height align-center justify-center ma-0>
              Click Here to Add Image File
            </v-layout>
          </v-responsive>
          <v-img v-if="value" :src="value.imageURL" aspect-ratio="1" contain="contain" :style="[rounded ? {'border-radius':'50%'} : {}]">
            <v-expand-transition>
              <div v-if="hover" class="d-flex transition-fast-in-fast-out secondary darken-2 v-card--reveal display-1 white--text text-xs-center" style="height: 30%;">
                <v-btn @click="launchFilePicker()">
                  Change
                </v-btn>
                <v-btn v-if="value" @click="cropperDialog = true">
                  Crop
                </v-btn>
              </div>
            </v-expand-transition>
          </v-img>
          <v-img v-if="originalImage && !value" :src="originalImage" aspect-ratio="1" :contain="contain" :style="[rounded ? {'border-radius':'50%'} : {}]">
            <v-expand-transition>
              <div v-if="hover" class="d-flex transition-fast-in-fast-out secondary darken-2 v-card--reveal display-1 white--text text-xs-center" style="height: 30%;">
                <v-btn @click="launchFilePicker()">
                  Change
                </v-btn>
              </div>
            </v-expand-transition>
          </v-img>
        </div>
      </div>
    </v-hover>

    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input ref="file" type="file" :name="uploadFieldName" style="display:none" @change="onFileChange($event.target.name, $event.target.files)">
    <!-- error dialog displays any potential errors -->
    <v-dialog v-model="errorDialog" max-width="300">
      <v-card>
        <v-card-text class="subheading">
          {{ errorText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="errorDialog = false">
            Got it!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- vue-cropper dialog -->
    <v-dialog v-if="value" v-model="cropperDialog" max-width="700" lazy>
      <v-card>
        <vue-cropper ref="cropper" :src="value.imageURL" :view-mode="1" drag-mode="move" :aspect-ratio="cropArea" :img-style="{ 'width': '500px', 'height': '500px' }" />
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="cropperDialog = false">
            Cancel
          </v-btn>
          <v-btn flat color="success" @click="cropImage">
            Crop Image
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import VueCropper from 'vue-cropperjs';

  export default {
    components: {
      VueCropper,
    },

    props: {
      // Use "value" here to enable compatibility with v-model
      value: Object,
      originalImage: String,
      rounded: Boolean,
      cropArea: {
        type: Number,
        default: NaN,
      },
      contain: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      fileName: '',
      errorDialog: null,
      cropperDialog: false,
      errorText: '',
      uploadFieldName: 'file',
    }),

    methods: {
      launchFilePicker() {
        this.$refs.file.click();
      },

      cropImage() {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const formData = new FormData();
          const imageURL = this.$refs.cropper.getCroppedCanvas().toDataURL();
          formData.append(this.uploadFieldName, blob, this.fileName);
          // Emit FormData & image URL to the parent component
          this.$emit('input', { formData, imageURL });
        });
        this.cropperDialog = false;
      },

      onFileChange(fieldName, file) {
        const { maxSize } = this;
        const imageFile = file[0];

        // check if user actually selected a file
        if (file.length > 0) {
          if (!imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.errorDialog = true;
            this.errorText = 'Please choose an image file';
          } else {
            this.fileName = imageFile.name;
            // Append file into FormData & turn file into image URL
            const formData = new FormData();
            const imageURL = URL.createObjectURL(imageFile);
            formData.append(fieldName, imageFile, this.fileName);
            // Emit FormData & image URL to the parent component
            this.$emit('input', { formData, imageURL });
          }
        }
      },
    },
  };
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    padding: 0 15px;
    opacity: 1;
    position: absolute;
    width: 100%;
  }
</style>